import { render } from "./CheckDetail.vue?vue&type=template&id=6720b2fd&scoped=true&ts=true"
import script from "./CheckDetail.vue?vue&type=script&lang=ts"
export * from "./CheckDetail.vue?vue&type=script&lang=ts"

import "./CheckDetail.vue?vue&type=style&index=0&id=6720b2fd&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6720b2fd"]])

export default __exports__